module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/land-rover-5d4c5de7263006cc7507c8a5c0bad4fa.png";